import {
  HeadMetatags,
  DefaultPageLayout,
  Container,
} from 'routes/components/Layout'
import { SelfHostingHero } from './components/Hero'
import { SelfHostingAdvantages } from './components/Advantages'
import classes from './SelfHosting.module.scss'

export const SelfHostingPage = () => {
  return (
    <DefaultPageLayout className={classes.page}>
      <HeadMetatags title={'Self-Hosting'} />
      <Container grid>
        <SelfHostingHero />
        <SelfHostingAdvantages />
      </Container>
    </DefaultPageLayout>
  )
}
